import { AfterViewChecked, AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { XWareLogService } from '../../services/xware-log.service';
import { CwMsalService } from '../../services/cw-msal.service';
import { CwGapiService } from '../../services/cw-gapi.service';

@Component({
  selector: 'xware-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewChecked, AfterViewInit, OnDestroy {
  public logout = false;
  public designerVersion: string;
  public isTrial = false;
  bShowGoogle = true;
  bShowAzure = true;

  private logoutResetInterval: ReturnType<typeof setInterval> | null = null;
  private googleButtonInterval: ReturnType<typeof setInterval> | null = null;

  constructor(
    public cwMsalService: CwMsalService,
    public cwGapiService: CwGapiService,
    private route: ActivatedRoute,
    private router: Router,
    private logger: XWareLogService
  ) {
    this.logger.log('Login:Start');

    if (this.route.snapshot.queryParams['logout']) {
      this.logger.log('Login:logout true');
      this.logout = true;
      this.logoutResetInterval = setInterval(() => {
        this.logout = false;
      }, 1500);
    } else {
      this.logout = false;
    }

    if (this.router.url.indexOf('/trial') > -1 || sessionStorage.getItem('onboarding') === 'Y') {
      this.isTrial = true;
      const signinType = this.route.snapshot.queryParams['si'];
      if (signinType === 'g') {
        this.bShowAzure = false;
        this.bShowGoogle = true;
      } else if (signinType === 'm') {
        this.bShowAzure = true;
        this.bShowGoogle = false;
      }
    } else {
      const signinType = this.route.snapshot.queryParams['show'];
      if (signinType) {
        if (signinType.toLowerCase() === 'gws') {
          this.bShowAzure = false;
          this.bShowGoogle = true;
        } else if (signinType === 'm365') {
          this.bShowAzure = true;
          this.bShowGoogle = false;
        }
      }
    }
  }

  ngOnInit(): void {
    this.designerVersion = environment.appVersion;
    localStorage.removeItem('AUId');
    sessionStorage.removeItem('AUId');
    const strTempInitVars = sessionStorage.getItem('initParams');
    sessionStorage.clear();
    sessionStorage.setItem('portalURL', environment.portalapiurl);
    sessionStorage.setItem('initParams', strTempInitVars ?? '');
    if (environment.rootUri) {
      sessionStorage.setItem('rooturi', environment.rootUri);
    }
  }

  ngAfterViewChecked(): void {
    this.renderGoogleButton();
  }

  ngAfterViewInit(): void {
    if (this.bShowGoogle) {
      this.googleButtonInterval = setInterval(() => this.renderGoogleButton(), 200);
    }
  }

  ngOnDestroy(): void {
    this.clearLogoutResetInterval();
    this.clearGoogleButtonInterval();
  }

  public signInAzure(): void {
    sessionStorage.setItem('adType', 'msal');
    this.cwMsalService.signInAzure();
  }

  private renderGoogleButton(): void {
    if (!this.bShowGoogle) {
      return;
    }
    const el = document.getElementById('btnLoginG');
    if (!el) {
      return;
    }
    if (el.innerHTML !== '') {
      this.clearGoogleButtonInterval();
      return;
    }
    this.cwGapiService.renderButton('btnLoginG');
  }

  private clearGoogleButtonInterval(): void {
    if (this.googleButtonInterval) {
      clearInterval(this.googleButtonInterval);
      this.googleButtonInterval = null;
    }
  }

  private clearLogoutResetInterval(): void {
    if (this.logoutResetInterval) {
      clearInterval(this.logoutResetInterval);
      this.logoutResetInterval = null;
    }
  }
}
